import { baseFetch } from 'src/utils';
import type { OrgMember, OrgQueriesData } from 'src/types';

/**
 * Fetches organization users with sorting, filtering, and searching options
 *
 * @param sortBy - Field to sort users by
 * @param filterBy - Filter criteria for users
 * @param searchBy - Search term for users
 * @param page - Page number to fetch
 * @returns Organization users data
 */
export const getOrgUsersAPI = async ({
  sortBy,
  filterBy,
  searchBy,
  page,
}: {
  sortBy: string;
  filterBy: string;
  searchBy: string;
  page: number;
}): Promise<OrgQueriesData> => {
  // URL encode parameters to handle special characters
  const queryParams = new URLSearchParams({
    sort: sortBy,
    filter: filterBy,
    search: searchBy,
    page: page.toString(),
  });

  const res = await baseFetch(`/api/org/users?${queryParams.toString()}`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!res.ok) {
    throw new Error('Failed to fetch org users');
  }

  const data = await res.json();

  const users = data.users as OrgMember[];
  const totalUsers = data.totalUsers as number;

  return { users, totalUsers, pageParam: page };
};
